import React from "react";


import Download_page from "../Public_Components/Download_page";

function Download() {
  return (
    <>
     
      <Download_page/>
      
      
     
    </>
  );
}

export default Download;
